import { render, staticRenderFns } from "./SourcingItemData.vue?vue&type=template&id=08325628&scoped=true"
import script from "./SourcingItemData.vue?vue&type=script&lang=js"
export * from "./SourcingItemData.vue?vue&type=script&lang=js"
import style0 from "./SourcingItemData.vue?vue&type=style&index=0&id=08325628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08325628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08325628')) {
      api.createRecord('08325628', component.options)
    } else {
      api.reload('08325628', component.options)
    }
    module.hot.accept("./SourcingItemData.vue?vue&type=template&id=08325628&scoped=true", function () {
      api.rerender('08325628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sourcing/SourcingItemData.vue"
export default component.exports